import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { NbDialogRef, NbDialogService } from '@nebular/theme';
import { OfbizFormsService } from '@urbannex/ofbiz-forms';
import { SectionBuilderStoreService } from '../../section-builder-store.service';
import { BaseCellStepper } from '../model';
import { ContentElement, ContentElementEnum, ContentEnum, ContentStatusEnum, GridCell, RowCell, Section } from '@urbannex/storethemes';
import { ConfigurationService } from '@urbannex/configuration';
import { Subscription, combineLatest } from 'rxjs';
import { ProductEditorDialogComponent } from '../../../../dialogs/product-editor-dialog/product-editor-dialog.component';

@Component({
  selector: 'kve-productlink-cell-stepper',
  templateUrl: './productlink-cell-stepper.component.html',
  styleUrls: ['./productlink-cell-stepper.component.scss']
})
export class ProductlinkCellStepperComponent implements OnInit,OnChanges{
  @Input() cell:GridCell | RowCell;
  @Input() section:Section;

  contentElements:ContentElement[];
  stepperTitle:string;
  lastStep = false;
  firstStep = true;
  showPlaceholder: boolean = true;
  baseUrl:string;

  imgSrc: string;

  contentEnum:ContentEnum;
  cntElementEnum = ContentElementEnum;
  currentCntElementEnum:ContentElementEnum;

  mode:string;

  /* dialogRef:Subscription;
  dialogRefClosed$:Subscription; */

  

  @Output() closeHostDialog = new EventEmitter<void>()

  
  constructor(
    private ref: NbDialogRef<ProductEditorDialogComponent>,
    private dialogService:NbDialogService,
    private ofbizFormsService:OfbizFormsService,
    private sectionBuilderStoreService:SectionBuilderStoreService,
    private configurationService:ConfigurationService,
    ){}
  
  
  ngOnChanges(changes: SimpleChanges): void {
    if(changes["cell"]){
      this.contentElements = this.cell.contentElements;
      this.contentEnum = this.cell.contentEnum;
      this.imgSrc = this.cell.imgSrc;
      this.stepperTitle = this.getStepperTitle(this.contentEnum)
    }
  }

  ngOnInit(): void {
    /* const dialogRef = this.dialogService.open(ProductEditorDialogComponent,{
      closeOnBackdropClick:true,
      context:{
        mode:this.mode,
      }
    }); */
    /* console.log(this.cell);
    this.contentEnum = this.cell.contentEnum;
    this.imgSrc = this.cell.imgSrc;
    console.log(this.contentEnum)
    
    this.contentElements = this.cell.contentElements; */
    this.baseUrl = this.configurationService.getBaseUrl();
    //this.sectionBuilderStoreService.updateSelectedCell(this.cell);

  }

  productDialog(mode:string){
    this.mode = mode;
    console.log("Oh yeah");
    
    /* this.dialogRef = this.dialogService.open(ProductEditorDialogComponent, {
      closeOnBackdropClick:true,
      context:{
        mode:mode,
      }
    }).onClose.subscribe(resp => {
      const formData = resp["data"]["formData"];
      let link = formData["link"];
      const formName = formData["formName"];
      const formLocation = formData["formLocation"];
      const parts = link.split('/');
      const productId = parts[parts.length - 1]
      console.log(productId);
      combineLatest([
        this.ofbizFormsService.getValue(formData,{productId:productId},null),
        this.ofbizFormsService.getValue({formName:"ProductSummary",formLocation:"component://kwikstore/widget/ProductForms.xml"},{productId:productId},null)
      ])
      .subscribe(([fieldsData,summaryData]:[any,any]) => {
        const formData = fieldsData["data"]["formData"];
        const fields = formData["fields"];
        this.populateContentElements(fields);
        const summary = summaryData["data"]["formData"]
        this.getImageSrc(summary["fields"]);
      })
      
    }) */

    
  }

  getStepperTitle(titleEnum){
    let title;
    if((titleEnum).includes(".")){
      let enumKey = titleEnum.split('.')[1] as keyof typeof ContentEnum;
      title = ContentEnum[enumKey];
    }else if(ContentEnum[titleEnum] != undefined){
      title = ContentEnum[titleEnum]
    }else{
      title = titleEnum;
    }
    
    console.log(title)
    
    return title;
  }

  populateContentElements(fields:any[]):void{
    //Product Name;
    //Price
    //Discount
    //Category
    //Release
    //Normal Price
    //Quick View
    //Release
    //Add to wish list
    //Add to cart
    console.log(this.contentElements);
    let productName = this.getFieldValue("productName",fields);
    console.log(productName);
    let productNameContentEl = this.contentElements.find(cntlEl => cntlEl.fieldName == "productName" || cntlEl.name == "Product Name");
    console.log(productNameContentEl);
    this.contentElements.forEach(contentElement => {
      if(contentElement.fieldName == "productName" || contentElement.name == "Product Name"){
        contentElement.text = this.getFieldValue("productName",fields);
        console.log(contentElement)
      }
      if(contentElement.fieldName == "price" || contentElement.name == "Price"){
        contentElement.text = this.getFieldValue("price",fields);
        console.log(contentElement)
      }
    })
    console.log(fields);
    


  }

  /**
     * 
     * @param fields Fields fetched from the backend and containing the image urls
     */
  getImageSrc(fields:any[]):void{
    //let productId = this.getFieldValue("productId",fields);
  //console.log(productId);
  let smallImageUrl = this.getFieldValue("smallImageUrl",fields);
  if(smallImageUrl != undefined){
    //clean url of htmlsafe characters
    smallImageUrl = decodeURIComponent(smallImageUrl);
    let baseUrl = this.baseUrl.replace("rest/","");
    this.imgSrc = baseUrl+smallImageUrl;
    this.cell.imgSrc = this.imgSrc;
    this.showPlaceholder = false;
    console.log(this.imgSrc)
  }
  //console.log(this.cell)
  //get the productSummary
}

  getFieldValue(nameKey, fields:any[]){
    let value;
      for (let i=0; i < fields.length; i++) {
        for (let [k,v] of Object.entries(fields[i])) {
          if(k == nameKey){
            //value =  fields[i][k];
            value = v
          }
        }
      }
    return value
  }

  onStepChange(e){
    if(e.index == (e.step.stepper.steps.length - 1)){
      this.lastStep = true;
    }
    if(e.index > 0){
      this.firstStep = false;
    }
  }

  getEnumValue(contentElement:ContentElement){
        let enumValue:string;
        let titleEnum = contentElement.contentElementEnum
        if(titleEnum != undefined){
          if((titleEnum).includes(".")){
            let enumKey = titleEnum.split('.')[1] as keyof typeof ContentElementEnum;
            enumValue = ContentElementEnum[enumKey];
          }else if(ContentElementEnum[titleEnum] != undefined){
            enumValue = ContentElementEnum[titleEnum]
          }else{
            enumValue = titleEnum;
          }
        }
        if(enumValue) enumValue = <string>enumValue.toUpperCase();
        
        return enumValue;
        /* console.log(titleEnum)
        let title;
        if((titleEnum).includes(".")){
          let enumKey = titleEnum.split('.')[1] as keyof typeof ContentElementEnum;
          title = ContentElementEnum[enumKey];
        }else if(ContentElementEnum[titleEnum] != undefined){
          title = ContentElementEnum[titleEnum]
        }else{
          title = titleEnum;
        }
        console.log(title)
        return title */
      }

  onSubmitContent(){
    console.log("onSubmitContent")
    this.cell.status = ContentStatusEnum.CTNT_INITIAL_DRAFT;
    this.section.status = ContentStatusEnum.CTNT_INITIAL_DRAFT;
    this.sectionBuilderStoreService.updateSection(this.section);
    this.sectionBuilderStoreService.updateSelectedCell(this.cell);
    this.closeHostDialog.emit();
  }

  selectProduct(resp){
    console.log(resp);
    const formName = resp["formName"];
    const formLocation = resp["formLocation"];
    const link = resp["link"];
    const parts = link.split('/');
    const productId = parts[parts.length - 1]
    console.log(productId);
    const formData = {formName:formName,formLocation:formLocation}
      combineLatest([
        this.ofbizFormsService.getValue(formData,{productId:productId},null),
        this.ofbizFormsService.getValue({formName:"ProductSummary",formLocation:"component://kwikstore/widget/ProductForms.xml"},{productId:productId},null)
      ])
      .subscribe(([fieldsData,summaryData]:[any,any]) => {
        const formData = fieldsData["data"]["formData"];
        const fields = formData["fields"];
        this.populateContentElements(fields);
        const summary = summaryData["data"]["formData"]
        this.getImageSrc(summary["fields"]);
      })
    /* const formData = resp["data"]["formData"];
      let link = formData["link"];
      const formName = formData["formName"];
      const formLocation = formData["formLocation"];
      const parts = link.split('/');
      const productId = parts[parts.length - 1]
      console.log(productId);
      combineLatest([
        this.ofbizFormsService.getValue(formData,{productId:productId},null),
        this.ofbizFormsService.getValue({formName:"ProductSummary",formLocation:"component://kwikstore/widget/ProductForms.xml"},{productId:productId},null)
      ])
      .subscribe(([fieldsData,summaryData]:[any,any]) => {
        const formData = fieldsData["data"]["formData"];
        const fields = formData["fields"];
        this.populateContentElements(fields);
        const summary = summaryData["data"]["formData"]
        this.getImageSrc(summary["fields"]);
      }) */
  }




}
